/**
 * Safe localStorage wrapper to handle sandboxed contexts
 * Prevents SecurityError when localStorage is not accessible
 */
(function (window) {
    'use strict';

    // Check if localStorage is available
    function isLocalStorageAvailable() {
        try {
            const testKey = '__localStorage_test__';
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }

    // In-memory fallback storage
    const memoryStorage = {};

    // Safe localStorage wrapper
    window.safeStorage = {
        getItem: function (key) {
            try {
                if (isLocalStorageAvailable()) {
                    return localStorage.getItem(key);
                }
                return memoryStorage[key] || null;
            } catch (e) {
                console.warn('localStorage access error:', e);
                return memoryStorage[key] || null;
            }
        },

        setItem: function (key, value) {
            try {
                if (isLocalStorageAvailable()) {
                    localStorage.setItem(key, value);
                } else {
                    memoryStorage[key] = String(value);
                }
            } catch (e) {
                console.warn('localStorage access error:', e);
                memoryStorage[key] = String(value);
            }
        },

        removeItem: function (key) {
            try {
                if (isLocalStorageAvailable()) {
                    localStorage.removeItem(key);
                } else {
                    delete memoryStorage[key];
                }
            } catch (e) {
                console.warn('localStorage access error:', e);
                delete memoryStorage[key];
            }
        },

        clear: function () {
            try {
                if (isLocalStorageAvailable()) {
                    localStorage.clear();
                } else {
                    for (let key in memoryStorage) {
                        if (memoryStorage.hasOwnProperty(key)) {
                            delete memoryStorage[key];
                        }
                    }
                }
            } catch (e) {
                console.warn('localStorage access error:', e);
                for (let key in memoryStorage) {
                    if (memoryStorage.hasOwnProperty(key)) {
                        delete memoryStorage[key];
                    }
                }
            }
        },
    };

    // Also add a direct getter for backward compatibility
    window.safeLocalStorage = window.safeStorage;
})(window);
